export default "__VITE_ASSET__DkcVNAQM__"